// VTEX/Tray são SPAs — trocar de produto (ou de categoria pra produto) navega via
// history.pushState/replaceState, sem recarregar a página. Sem isso, o script só
// roda uma vez no load inicial e schema/tracking ficam presos na primeira PDP
// visitada. popstate sozinho não basta: cobre back/forward do browser, mas não
// pushState/replaceState (como o próprio framework navega internamente).
export function onLocationChange(callback: () => void): void {
  let lastHref = location.href;

  const notifyIfChanged = () => {
    if (location.href === lastHref) return;
    lastHref = location.href;
    callback();
  };

  for (const method of ["pushState", "replaceState"] as const) {
    const original = history[method];
    history[method] = function (this: History, ...args: Parameters<History[typeof method]>) {
      const result = original.apply(this, args);
      notifyIfChanged();
      return result;
    };
  }

  window.addEventListener("popstate", notifyIfChanged);
}
